<div class="row justify-content-center">
  <div class="col-12">
    <div class="card">

      <div class="card-body">

        <div class="p-2">
          <div class="text-center">

            <div class="avatar-md mx-auto">
              <div class="avatar-title rounded-circle bg-light">
                <i class="mdi mdi-form-textbox-password h1 mb-0 text-primary"></i>
              </div>
            </div>
            <div class="p-2 mt-4">

              <h4>Change Password</h4>
              <p class="mb-5">You are required to change your password</p>

              <form [formGroup]="changePassword" class="need-validation" (submit)="onSubmit()">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <label class="label">Current Password</label>
                    <input type="password" formControlName="currentPassword" nbInput fullWidth class="form-control"
                      [ngClass]="{'is-invalid': formDataSubmit && f.currentPassword.errors}">
                    <div *ngIf="formDataSubmit && f.currentPassword.errors" class="invalid-feedback">
                      <span *ngIf="f.currentPassword.errors.required">Current Password is required</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <label class="label">New Password</label>
                    <input type="password" formControlName="newPassword" nbInput fullWidth class="form-control"
                      [ngClass]="{'is-invalid': formDataSubmit && f.newPassword.errors}">
                    <div *ngIf="formDataSubmit && f.newPassword.errors" class="invalid-feedback">
                      <span *ngIf="f.newPassword.errors.required">New Password is required</span>
                      <span *ngIf="f.newPassword.errors.pattern">Minimum 8 characters, at least one uppercase
                        letter, one lowercase letter, at least one special character （.~@$!%*#?&） and one number</span>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <label class="label">Confirm Password</label>
                    <input type="password" formControlName="confirmPassword" nbInput fullWidth class="form-control"
                      [ngClass]="{'is-invalid': formDataSubmit && f.confirmPassword.errors}">
                    <div *ngIf="formDataSubmit && f.confirmPassword.errors" class="invalid-feedback">
                      <span *ngIf="f.confirmPassword.errors.required">Confirm Password is required</span>
                      <div *ngIf="f.confirmedPassword.errors.confirmedValidator">Password and Confirm Password
                        must be match.</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-2 col-md-6 col-sm-12">
                    <button type="reset" class="btn btn-danger btn-block" (click)="resetForm()">Reset</button>
                  </div>
                  <div class="col-lg-2 col-md-6 col-sm-12">
                    <button type="submit" class="btn btn-primary btn-block">Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>